import React, { useState } from "react";
import store from "../Contact/Store"; // Your store data
import { FaMapMarkerAlt, FaMobileAlt, FaCaretDown } from "react-icons/fa";

const Shoping = () => {
  const [filterStore, setFilterStore] = useState(store);
  const [activeColor, setActiveColor] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false); // Toggle dropdown

  const filterItems = (category) => {
    const filtered = store.filter((currElm) => currElm.category === category);
    setFilterStore(filtered);
    setActiveColor(category);
  };

  return (
    <>
      <div className="bg-gray w-full h-full flex justify-center flex-col pb-10">
        {/* Title */}
        <div className="flex flex-col items-center justify-center">
          <div className="font-bold flex items-center justify-center text-lg text-black shadow w-full pt-4 pb-4">
            OUR SHOWROOM LOCATIONS
          </div>

          {/* Dropdown Button */}
          <div className="flex justify-center mt-5">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="bg-[#800000] text-white px-6 py-2 rounded flex items-center space-x-2 shadow-md hover:bg-[#600000] transition-all duration-300"
            >
              <span>{dropdownOpen ? "Hide Stores" : "Show Stores"}</span>
              <FaCaretDown
                className={`transition-transform duration-300 ${
                  dropdownOpen ? "rotate-180" : ""
                }`}
              />
            </button>
          </div>

          {/* Dropdown Content (Filter Buttons + Store Cards) */}
          {dropdownOpen && (
            <div className="w-full mt-5 p-5 bg-white shadow-lg rounded-lg transition-all duration-300">
              {/* Filter Buttons */}
              <div className="flex items-center space-x-3 justify-center mb-5">
                <button
                  className={`pl-10 pr-10 text-black shadow font-medium text-base pt-2 pb-2 rounded transition-all duration-300 ${
                    activeColor === "Karnataka"
                      ? "bg-[#800000] text-white"
                      : "bg-white border border-gray-400"
                  }`}
                  onClick={() => filterItems("Karnataka")}
                >
                  Karnataka
                </button>
                <button
                  className={`pl-10 pr-10 text-black shadow font-medium text-base pt-2 pb-2 rounded transition-all duration-300 ${
                    activeColor === "Andhra"
                      ? "bg-[#800000] text-white"
                      : "bg-white border border-gray-400"
                  }`}
                  onClick={() => filterItems("Andhra")}
                >
                  Andhra
                </button>
              </div>

              {/* Store Cards */}
              <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-6 gap-4">
                {filterStore.map((item) => (
                  <div
                    key={item.id}
                    className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden"
                  >
                    {/* Store Details */}
                    <div className="p-4 flex flex-col">
                      {/* Location */}
                      <h1 className="text-lg font-bold flex items-center text-[#800000]">
                        <FaMapMarkerAlt className="mr-2 text-[#800000]" />
                        {item.location}
                      </h1>

                      {/* Address */}
                      <p className="text-xs text-gray-700">
                        <a
                          href={item.map}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:text-[#800000] transition-colors duration-300"
                        >
                          {item.address}
                        </a>
                      </p>

                      {/* Contact Numbers */}
                      <div className="flex flex-wrap items-center gap-2 mt-2">
                        <a
                          href={`tel:${item?.number1}`}
                          className="flex items-center text-sm text-gray-800 hover:text-[#800000]"
                        >
                          <FaMobileAlt className="mr-1" /> {item.number1}
                        </a>
                        {item?.number2 && (
                          <>
                            <span className="text-gray-500">,</span>
                            <a
                              href={`tel:${item?.number2}`}
                              className="flex items-center text-sm text-gray-800 hover:text-[#800000]"
                            >
                              {item.number2}
                            </a>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Shoping;
